module.exports = __webpack_public_path__ + "img/avatar6.262d919d.png";